import { UserIcon } from 'components/Icons';
import { WebsiteIcon } from 'components/Icons/WebsiteIcon';
import { AssociadoRoutePath } from 'library/Routes';
import translation from 'locales/translation';
import {
  Button,
  ButtonThemes,
  Header,
  HeaderType,
  SicrediLogo,
} from 'plataforma-fundacao-componentes';
import React from 'react';
import { history } from 'store/Store';
import FooterSicredi from '../footerSicredi/footerSicredi';
import styles from './PublicContainer.scss';
const rootClassName = styles.rootClassName;
interface Props {
  children: React.ReactNode;
  readOnly?: boolean;
  maintenance?: boolean;
}

export default function PublicContainer(props: Props) {
  return (
    <article className={rootClassName} id='public-container'>
      {props.readOnly ? undefined : (
        <Header
          theme={HeaderType.Assembleia}
          separator={{
            show: true,
            label: translation.LoginAssociado.tituloPagina,
          }}
          leftContent={<SicrediLogo height={30} />}
          blackBar={{
            show: true,
            icon: <WebsiteIcon />,
            label: translation.LoginAssociado.acesseSicredi,
            link: 'https://sicredi.com.br',
            target: '_blank',
          }}
          rightContent={
            <>
              <Button
                leftIcon={<UserIcon />}
                theme={ButtonThemes.Primary}
                onClick={() => history.push(AssociadoRoutePath)}
                w100
              >
                {translation.LoginAssociado.botao}
              </Button>
            </>
          }
        />
      )}
      <div className={`${rootClassName}-content`}>{props.children}</div>
      {props.readOnly ? undefined : (
        <FooterSicredi
          theme='secondary-lighter'
          midiasSociais
          maxWidth={1600}
        />
      )}
    </article>
  );
}
